export default __webpack_public_path__ + "assets/ico_previous-d590237e.svg";